import { render, staticRenderFns } from "./ChangeConsultantRoleSidebar.vue?vue&type=template&id=a8b1f1ce"
import script from "./ChangeConsultantRoleSidebar.vue?vue&type=script&lang=js"
export * from "./ChangeConsultantRoleSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports